export default __webpack_public_path__ + "static/media/chart-kattami-bg.3c7b3216.jpg";